"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var remove_attrs_1 = require("./remove-attrs");
exports.removeAttrs = remove_attrs_1.default;
